export default __webpack_public_path__ + "static/media/gus-rsi-logo-horizontal-en.2ed51ed1.png";